<div class="details-container">
    <span class="container-box" *ngFor="let item of aggregateTrendsDetails" [style.backgroundColor]="item.color">
        <div class="value-row">
            <span class="value">{{item['field_value'] | indianNumberFormat }}</span>
            <span class="card-deviation"
                *ngIf="isDeviationEnabled && item.deviation != null"
                [ngClass]="{
                    'deviation-up': item.deviation.arrowType === 'up',
                    'deviation-down': item.deviation.arrowType === 'down',
                    'deviation-no-change': item.deviation.arrowType === 'no-change'
                }">
                {{item.deviation.deviation}}<i *ngIf="item.deviation.arrowType === 'up'" class="fa fa-arrow-up deviation-arrow"></i><i *ngIf="item.deviation.arrowType === 'down'" class="fa fa-arrow-down deviation-arrow"></i>
            </span>
        </div>
        <div class="comparison-label" *ngIf="isDeviationEnabled && comparisonLabel">vs {{ comparisonLabel }}</div>
        <div class="text">{{item['display_name']}}</div>
    </span>
</div>
